export const TABLE_BILLING = [
    "#",
    "Date",
    "Bill Number",
    "Customer Name",
    "Bill Mode",
    "Payment Period",
    "Gross Bill",
    "GST",
    "Net Bill",
    "Action",
];

export const TABLE_PO = [
    "#",
    "PO Date",
    "Vendor Name",
    "Gross Value",
    "GST Amount",
    "Net Value",
    "Status",
    "Details",
];
export const CADRE_IDS = {
    1: "Stores",
    2: "Manager",
    3: "Accounts",
    4: "Unit Head",
    5: "System Admin",
};
